import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Badge } from '@gik/ui/Badge';
import { Grid } from '@gik/ui/Grid';
import { HTMLParser } from '@gik/ui/HTMLParser';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureContent } from '../FeatureContent';
import { translationKeys } from './i18n/en';

export const FeaturesStepsGridBlockName = 'feature-steps-grid';

function FeatureStepsGridComp(): React.ReactElement {
  const bem = bemBlock(FeaturesStepsGridBlockName);
  const { t } = useTranslation();
  const blockClasses = bem(null, null);

  return (
    <Grid className={blockClasses}>
      <FeatureContent
        variant="primary"
        title={
          <div className={bem('feature_title')}>
            <Badge className={bem('badge')} variant="primary" circle block size="lg">
              1
            </Badge>
            <br />
            <h2 className={bem('title_copy')}>{t(translationKeys.createTitle).toString()}</h2>
          </div>
        }
        titleCentered
      >
        <div className="gik-hidden-md">{HTMLParser({ rawHtml: t(translationKeys.createDescription) })}</div>
      </FeatureContent>

      <FeatureContent
        variant="danger"
        title={
          <div className={bem('feature_title')}>
            <Badge className={bem('badge')} variant="danger" circle block size="lg">
              2
            </Badge>
            <br />
            <h2 className={bem('title_copy')}>{t(translationKeys.customizeTitle).toString()}</h2>
          </div>
        }
        titleCentered
      >
        <div className="gik-hidden-md">{HTMLParser({ rawHtml: t(translationKeys.customizeDescription) })}</div>
      </FeatureContent>
      <FeatureContent
        variant="secondary"
        title={
          <div className={bem('feature_title')}>
            <Badge className={bem('badge')} variant="secondary" circle block size="lg">
              3
            </Badge>
            <br />
            <h2 className={bem('title_copy')}>{t(translationKeys.shareTitle).toString()}</h2>
          </div>
        }
        titleCentered
      >
        <div className="gik-hidden-md">{HTMLParser({ rawHtml: t(translationKeys.shareDescription) })}</div>
      </FeatureContent>

      <div className="gik-hidden-sm-down">{HTMLParser({ rawHtml: t(translationKeys.createDescription) })}</div>

      <div className="gik-hidden-sm-down">{HTMLParser({ rawHtml: t(translationKeys.customizeDescription) })}</div>

      <div className="gik-hidden-sm-down">{HTMLParser({ rawHtml: t(translationKeys.shareDescription) })}</div>
    </Grid>
  );
}

export const FeatureStepsGrid = withComponentErrorBoundary(FeatureStepsGridComp);
